<div class="modal-header">
  <h2 class="modal-title" id="modal-basic-title">Choose a subscription plan</h2>

  <button
    data-dd-action-name="view-pricing-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="isUpdating"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <app-subscription-packages
    [destinationRouteCommand]="destinationRouteCommand"
    [newOrganisation]="newOrganisation"
    (close)="close()"
    (packageUpdated)="onPackageUpdated()"
    (updating)="isUpdating = $event"
  ></app-subscription-packages>
</div>
